module.exports = __webpack_public_path__ + "img/10d.3a127a13.png";